// src/context/CartContext.js
import React, { createContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    try {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) setCart(JSON.parse(savedCart));
    } catch {
      localStorage.removeItem('cart');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, selectedColor = null) => {
    setCart((prev) => {
      const exists = prev.find((item) => item._id === product._id && item.selectedColor === selectedColor);
      if (exists) {
        return prev.map((item) => item._id === product._id && item.selectedColor === selectedColor ? { ...item, quantity: item.quantity + 1 } : item);
      }
      // Store the effective (post-discount) price so checkout charges correctly
      const effectivePrice = product.discount > 0
        ? Math.round(product.price * (1 - product.discount / 100))
        : product.price;
      return [...prev, { ...product, price: effectivePrice, quantity: 1, selectedColor }];
    });
    toast.success('Added to cart');
  };

  const removeFromCart = (id, selectedColor) => {
    setCart((prev) => prev.filter((item) => !(item._id === id && item.selectedColor === selectedColor)));
    toast.success('Removed from cart');
  };

  const updateQuantity = (id, quantity, selectedColor) => {
    if (quantity < 1) return removeFromCart(id, selectedColor);
    setCart((prev) => prev.map((item) => item._id === id && item.selectedColor === selectedColor ? { ...item, quantity } : item));
  };

  // Buy Now - clears cart and adds only this product at effective price
  const buyNow = (product, selectedColor = null) => {
    const effectivePrice = product.discount > 0
      ? Math.round(product.price * (1 - product.discount / 100))
      : product.price;
    setCart([{ ...product, price: effectivePrice, quantity: 1, selectedColor }]);
  };

  const clearCart = () => {
    setCart([]);
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, buyNow, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartContext;